import React from "react";
import Loader from "../Loader";
import { Button } from "@mui/material";
import { Link, useNavigate, NavLink } from "react-router-dom";
import "./Error.scss";
import construct from "../../Img/construct.svg"

const UnderConstruction = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader /> */}
      <div className="pagenotfound-page display-2 text-center">
        <div className="contain-width">
          <div className="pagenotfound-img">
              < img src={construct}/>
          </div>
          <div className="pagenotfound-content">
            <h1>
            Under Construction
            </h1>
            <p>
             We are currently working on this feature and will launch soon!
            </p>
            <div className="common-btn mt-10">
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={() => {
                  navigate("/");
                }}
              >
                Back to Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnderConstruction;






